// extracted by mini-css-extract-plugin
export default {"container":"header_container__7HyC8","arrow":"header_arrow__K6XX9","title":"header_title__3nbMi"};